import useGetTickets from './useGetTickets'

export default useGetTickets
